import script from "./franchiseInvoice.vue?vue&type=script&setup=true&lang=js"
export * from "./franchiseInvoice.vue?vue&type=script&setup=true&lang=js"

import "./franchiseInvoice.vue?vue&type=style&index=0&id=3fa6d676&lang=css"

const __exports__ = script;

export default __exports__